<template>
    <v-container fluid>
        <v-row
            justify="center"
        >            
            <v-col>
                <v-card
                    class="pa-0 mx-auto"
                    width="950"                    
                >
                    <v-overlay
                        absolute
                        :value="overlay"                    
                        color="grey lighten-5"
                        opacity="0.9"                    
                    >                    
                        <v-expand-transition>
                            
                            <v-card
                                max-width="300"
                                class="mx-auto"
                                transition="scroll-y-transition"
                                v-show="expand"
                                light 
                            >
                                <v-toolbar
                                    color="primary"
                                    dark
                                >
                                    <v-toolbar-title>Select Class</v-toolbar-title>
                                </v-toolbar>
                                <div style="max-height: 400px; width: 250px; overflow-y: auto">    
                                <v-list light >
                                    <v-list-group
                                        v-for="item in formClasses"
                                        :key = "item.title"
                                        v-model="item.active"
                                        :prepend-icon="item.action"
                                        no-action
                                    >
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ item.title }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <v-list-item
                                            v-for="subItem in item.items"
                                            :key="subItem.title"
                                            @click="setSelectedClass(subItem)"                                       
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title >
                                                    {{ subItem.title }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-group>
                                </v-list>
                                </div>                     
                            </v-card>
                            
                        </v-expand-transition>

                        <v-expand-transition>
                            <v-card
                                max-width="300"
                                class="mx-auto"
                                transition="scroll-y-transition"
                                v-show="expandTerms"
                                light 
                            >
                                <v-toolbar
                                    color="primary"
                                    dark
                                >
                                    <v-toolbar-title>{{ reportMenuTitle }}</v-toolbar-title>
                                </v-toolbar>

                                <v-list 
                                    light
                                    v-if="selectTerm" 
                                >
                                    <v-list-item-group>
                                        <v-list-item
                                            v-for="(item, i) in termsAvailable"
                                            :key="i"
                                            @click="setSelectedTerm(item)"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>Term {{ item.title}}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>    
                                </v-list>

                                <v-card-text
                                    v-else
                                >
                                    Select Format
                                    <v-radio-group
                                        v-model="radioGroup"
                                    >
                                        <v-radio
                                            label="PDF"
                                            value="pdf"
                                        ></v-radio>
                                        <v-radio
                                            label="Excel"
                                            value="excel"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-card-text>

                                <v-card-actions v-if="!selectTerm">
                                    <v-btn
                                        color="primary"
                                        outlined
                                        small
                                        @click="closeReportMenu"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        dark
                                        small
                                        @click="setFormat"
                                    >
                                        Generate Mark Sheet
                                    </v-btn>
                                </v-card-actions>    
                            </v-card>
                        </v-expand-transition>

                        <v-progress-circular 
                            transition="fade-transition" 
                            indeterminate 
                            size="64"
                            v-show="loading"
                            color="blue"
                        ></v-progress-circular>

                    </v-overlay>
                    
                    <v-card-title 
                        class="primary pa-0"
                    >                        
                        <v-container>
                            <v-row class="mx-0 white--text">
                                <v-col
                                    class="pa-0 flex-grow-0 mr-4"
                                    align-self="center"
                                >
                                    <v-card 
                                        flat
                                        width="150"
                                        color="primary"
                                        class="white--text pl-4"
                                        style="font-size:0.7rem"
                                    >
                                        {{ saveStatus }}
    
                                        <v-progress-circular
                                            indeterminate
                                            v-show="saving"
                                            size="16"
                                            width="3"
                                            class="ml-3"
                                            color="white"
                                        ></v-progress-circular>
                                    
                                        
                                        <v-icon
                                            small
                                            color="white"
                                            v-show="saved"
                                            class="ml-3"
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    
                                        <v-icon
                                            small
                                            color="red"                   
                                            v-show="saveError"
                                            class="ml-3"
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-card> 
                                    
                                </v-col>  
    
                                <v-col 
                                    style="letter-spacing: 1px; text-transform: uppercase; font-weight: bold"
                                    class="pa-0 text-subtitle-2  d-flex justify-center"
                                    align-self="center"
                                >
                                    Edit / View Term Reports
                                </v-col>
                                
                                <v-col 
                                    class="pa-0 flex-grow-0"
                                    align-self="center"
                                >
                                    <v-btn
                                        text                
                                        x-small
                                        color="white"
                                        @click="closeEditViewTermReports"
                                    >
                                        <v-icon>mdi-window-close</v-icon>
                                    </v-btn>
                                </v-col>
    
                            </v-row>                            

                        </v-container>
                    </v-card-title>

                    <div class="d-flex">
                        <student-details
                            @setOverlay="setOverlayProcessing"
                        ></student-details>

                        <subject-records></subject-records>
                    </div>

                     <v-overlay
                        absolute
                        :value="overlayProcessing"
                    >
                        <v-progress-circular
                            indeterminate
                            size="64"
                            color="primary"
                        ></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-col>           
        </v-row>

        <!-- Reoprt Dialog -->
        <v-dialog
            v-model="dialogReport"
            max-width="90vw"
            persistent            
        >
            <v-card height="80vh" v-if="dialogReport">
                <iframe 
                    ref="pdf" 
                    style="width:100%; height:100%" 
                    frameBorder="0" 
                    :src="src"
                    @load="pdfLoaded"
                ></iframe>
                <v-overlay
                    absolute
                    :value="overlayReport"
                    color="white"
                    opacity="0.60"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>                
            </v-card>
            <v-container
                fluid
                class="pa-0"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >
                        <v-btn
                            color="primary"
                            small
                            dark
                            @click="closeReport"
                            class="my-2 mr-4"
                        >
                            Close
                        </v-btn>
                    </v-row>
                </v-sheet>
            </v-container>
        </v-dialog>

        <v-bottom-sheet 
            v-model="sheet" 
            inset
            persistent
        >
            <v-row align="center" justify="center">
                <v-alert
                    :value="error"
                    prominent
                    type="error"
                    transition="scale-transition"
                    dense                        
                >
                    <v-row align="center">
                        <v-col>{{ errorMessage }}</v-col>
                    </v-row>
                </v-alert>
            </v-row>

            <v-sheet class="text-center px-10" height="200px">
                <v-row justify="end">
                    <div>
                        <v-btn
                            class="mt-1"
                            text
                            color="primary"
                            @click="closeBottomSheet"
                        >close</v-btn>
                    </div>
                </v-row>                
                <v-form ref="form">
                    <v-textarea                                       
                        :label="bottomSheetTitle"                        
                        hint="Max 215 Characters"
                        rows="3"                                           
                        counter                                             
                        no-resize
                        v-model="bottomSheetModel"
                        autofocus                        
                        persistent-hint
                        maxlength="215"                                                                                                                 
                    >                        
                    </v-textarea>
                </v-form>                    
            </v-sheet>
        </v-bottom-sheet>

        <v-dialog
            v-model="dialogDelete.display"
            max-width="550px"
        >
            <v-card>
                <v-card-title>{{ dialogDelete.text }}</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="dialogDelete.cancel" 
                        color="primary"
                        outlined
                        @click="closeDelete"
                        small
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        v-if="dialogDelete.deleteSubject"
                        color="primary"
                        @click="deleteSubjectConfirm"
                        small
                    >
                        Delete
                    </v-btn>
                    <v-btn
                        v-if="dialogDelete.deleteStudent"
                        color="primary"
                        @click="deleteStudentConfirm"
                        small
                    >
                        Delete Term Record
                    </v-btn>
                    <v-btn
                        v-if="dialogDelete.ok"
                        color="primary"
                        outlined
                        @click="closeDelete"
                        small
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
            
        </v-dialog>

        <v-snackbar
            v-model="snackbar.display"
            :color="snackbar.color"
        >
            {{ snackbar.text }}
            
            <template v-slot:action="{ attrs }">
                <v-btn
                    v-bind="attrs"
                    @click="snackbar.display = false"
                    text
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>

       
        
    </v-container>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import StudentDetails from './EditViewTermReportsStudentDetails';
import SubjectRecords from './EditViewTermReportsSubjectRecords';
export default {
    components: {
        StudentDetails,
        SubjectRecords,
    },   

    data: () => ({       
        error: false,
        errorMessage: '',       
        bottomSheetModel: '',
        overlayReport: false,
        src: '',
        selectTerm: false,
        selectedTerm: '',
        radioGroup: "pdf",  
        reportLoaded: false,  
        snackbar: {
            display: false,
            text: '',
            color: ''
        },
        overlayProcessing: false,    
    }),

    created: function () {
        this.initialize();
    },

    computed: {
        ...mapGetters({ 
            overlay: 'termReports/getEditViewTermReportsOverlay',
            loading: 'termReports/getEditViewTermReportsLoading',
            expand: 'termReports/getEditViewTermReportsExpand',
            formClasses: 'termReports/getFormClasses',
            studentRecord: 'termReports/getSelectedStudentRecord',
            sheet: 'termReports/getCommentSheet',
            model: 'termReports/getBottomSheetModel',
            bottomSheetTitle: 'termReports/getBottomSheetTitle',
            dialogDelete: 'admin/getDialogDelete',
            selectedTable2Record: 'admin/getSelectedTable2Record',
            selectedTable1Record: 'admin/getSelectedTable1Record',
            saveStatus: 'termReports/getEditViewTermReportsSaveStatus',
            saving: 'termReports/getEditViewTermReportsSaving',
            saveError: 'termReports/getEditViewTermReportsSaveError',
            saved: 'termReports/getEditViewTermReportsSaved',
            expandTerms: 'termReports/getExpandTerms',
            termsAvailable: 'termReports/getTermsAvailable',
            dialogReport: 'termReports/getDialogReport',
            srcObject: 'termReports/getSrc',
            admin: 'auth/getAdmin',
            selectedFormClass: 'termReports/getSelectedFormClass',
            editTermReports: 'admin/getEditTermReports',
        }),

        reportMenuTitle () {
            if(this.selectTerm) return "Select Report Term";
            else return "Select Format";
        }              
    },
    
    watch: {
        // formClasses: {
        //     handler: function () {                               
        //         this.setLoading(false);
        //         setTimeout(() => {this.setExpand(true)}, 700);
        //          this.setExpand(true);
        //     }
        // },

        model: {
            handler: function (val){
                this.bottomSheetModel = this.studentRecord[val];
            }
        },
        
        studentRecord: {    
            handler: function (){                
                this.bottomSheetModel = this.studentRecord[this.model];
            }
        },

        expandTerms: {
            handler: function (val) {
                if(val) this.selectTerm = true;
            }
        },

        expand: {
            handler: function () {
                //
            }
        }
       
    },
    
    methods: {
        ...mapMutations({
            setOverlay: 'termReports/setEditViewTermReportsOverlay',
            setLoading: 'termReports/setEditViewTermReportsLoading',
            setExpand: 'termReports/setEditViewTermReportsExpand',
            setSelectedFormClass: 'termReports/setSelectedFormClass',
            setSelectedStudentRecord: 'termReports/setSelectedStudentRecord',
            setPagination: 'termReports/setPagination',
            setCommentSheet: 'termReports/setCommentSheet',
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            editViewTermReports: 'termReports/setEditViewTermReports',
            welcomeMessage: 'termReports/setWelcomeMessage',
            mainMenu: 'termReports/setMainMenu',
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
            setTable1Records: 'termReports/setTable1Records',
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects',
            setTermsAvailable: 'termReports/setTermsAvailable',
            setSubjects: 'admin/setSubjects',
            setCodedComments: 'termReports/setCodedComments',
            setDialogDelete: 'admin/setDialogDelete',
            setSnackbar: 'admin/setSnackbar',
            setExpandTerms: 'termReports/setExpandTerms',
            setDialogReport: 'termReports/setDialogReport',
            setSubjectWeightings: 'termReports/setSubjectWeightings',
            setFormClasses: 'termReports/setFormClasses',
            setSrc: 'termReports/setSrc',
            setSelectedFormLevel: 'termReports/setSelectedFormLevel',
           
        }),

        ...mapActions({
            getTable1Record: 'termReports/getTable1Record',
            getTable2Records: 'termReports/getTable2Records',
            postTable1Record: 'termReports/postTable1Record',
            setErrorResponse: 'termReports/setErrorResponse',
            getSubjects: 'admin/getSubjects',
            deleteTable2Record: 'admin/deleteTable2Record',
            deleteTable1Record: 'admin/deleteTable1Record',
            downloadExcelMarksheet: 'termReports/dowloadExcelMarkSheet',
            getFormClasses: 'termReports/getFormClasses',
            getCodedComments: 'termReports/getCodedComments',
        }),

        async initialize () {
            this.setFormClasses([]);
            this.setOverlay(true);
            this.setLoading(true);
            try {
                const [
                    { data: dataCodedComments },
                    { data: dataFormClasses}
                ] = await Promise.all([
                    this.getCodedComments(),
                    this.getFormClasses()                    
                ])
                this.setCodedComments(dataCodedComments);
                await this.mapFormClasses(dataFormClasses)
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            this.setLoading(false);
            setTimeout(() => {this.setExpand(true)}, 700);
        },

        mapFormClasses (data) {
            return new Promise((resolve) => {
                let formClasses = [];
                let form1Classes = [];
                let form2Classes = [];
                let form3Classes = [];
                let form4Classes = [];
                let form5Classes = [];
                let form6Classes = [];            
                
                data.forEach(record => {
                    switch(record.form_level){
                        case 1:
                        form1Classes.push({
                            title: record.class_id,
                            formLevel: record.form_level
                        });
                        break;
                        case 2:
                        form2Classes.push({
                            title: record.class_id,
                            formLevel: record.form_level
                        });
                        break;
                        case 3:
                        form3Classes.push({
                            title: record.class_id,
                            formLevel: record.form_level
                        });
                        break;
                        case 4:
                        form4Classes.push({
                            title: record.class_id,
                            formLevel: record.form_level
                        });
                        break;
                        case 5:
                        form5Classes.push({
                            title: record.class_id,
                            formLevel: record.form_level
                        });
                        break;
                        case 6:
                        form6Classes.push({
                            title: record.class_id,
                            formLevel: record.form_level
                        });
                        break;
                        case 7:
                        form6Classes.push({
                            title: record.class_id,
                            formLevel: record.form_level
                        });
                        break;
                    }                
                });
                formClasses.push({
                    title: 'Form 1',
                    action: 'mdi-school',                
                    items: form1Classes
                });
                formClasses.push({
                    title: 'Form 2',
                    action: 'mdi-school',                
                    items: form2Classes
                });
                formClasses.push({
                    title: 'Form 3',
                    action: 'mdi-school',                
                    items: form3Classes
                });
                formClasses.push({
                    title: 'Form 4',
                    action: 'mdi-school',                
                    items: form4Classes
                });
                formClasses.push({
                    title: 'Form 5',
                    action: 'mdi-school',                
                    items: form5Classes
                });
                formClasses.push({
                    title: 'Form 6',
                    action: 'mdi-school',                
                    items: form6Classes
                }); 
    
                this.setFormClasses(formClasses);
    
                resolve(formClasses);
            })

        },

        showMainMenu () {
            // this.setExpand(false);
            this.editViewTermReports(false);            
            this.welcomeMessage(true);
            this.mainMenu(true); 
        },

        async setSelectedClass ({ title:formClass, formLevel }) {
            this.setSelectedFormClass(formClass);
            this.setSelectedFormLevel(formLevel);

            this.setExpand(false);
            
            await new Promise((resolve) => {
                setTimeout(() => {
                    this.setLoading(true);
                    resolve();
                }, 600);
            });
            
            await this.setStudentRecords();
            this.setOverlay(false);
            this.setLoading(false);
        },

        async setStudentRecords () {
            try {
                const [
                    { data: dataTable1Records },
                    { data: dataSubjects }
                ] = await Promise.all([
                    this.getTable1Record(),
                    this.getSubjects()
                ])

                this.setSubjects(dataSubjects);
                
                this.makePagination(dataTable1Records);
                this.setTable1Records(dataTable1Records.data);
                if(dataTable1Records.data.length > 0){
                    this.setSelectedStudentRecord(dataTable1Records.data[0]);
                } 

                const { data: dataTable2Records } = await this.getTable2Records();
                this.setTable2Records(dataTable2Records.table2_records);
                this.setStudentSubjects(dataTable2Records.student_subjects);
                this.setTermsAvailable(dataTable2Records.terms);
                this.setSubjectWeightings(dataTable2Records.subject_weightings)

            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
                                
        },

        closeBottomSheet () {            
            this.setCommentSheet(false);
            this.updateRecord();
        },

        makePagination (data) {
            let pagination = {
                current_page: 1,
                last_page: data.data.length,
                next_page: 2,
                prev_page: null,
            }
            this.setPagination(pagination);
        },

        closeEditViewTermReports () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        async updateRecord(){
            this.setSaveStatus('Saving...');
            this.studentRecord[this.model] = this.bottomSheetModel;
            this.setSaving(true);
            this.setSaved(false);
            this.setSaveError(false);
            try{
                await this.postTable1Record();
                this.setSaveStatus('Record Saved');
                this.setSaving(false);
                this.setSaved(true);
                this.setSaveError(false);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.setSaveStatus('Error Occured');
                this.setSaving(false);
                this.setSaved(false);
                this.setSaveError(true);
                this.setErrorResponse(error);
            }
            
        },
        
        closeDelete () {
            let dialogDelete = {...this.getDialogDelete};
            dialogDelete.display = false;
            this.setDialogDelete(dialogDelete);
        },

        async deleteSubjectConfirm () {
            let response = null;
            this.closeDelete();

            this.$nextTick(() => {
                this.setOverlay(true);
                this.setLoading(true);
            })
            
            try {
                await this.deleteTable2Record();

                response = await this.getTable2Records();
                this.setTable2Records(response.data.table2_records);
                this.setStudentSubjects(response.data.student_subjects);
                this.setSnackbar({
                    text: `${this.selectedTable2Record.title} deleted.`,
                    display: true,
                    color: 'primary',
                });
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.setSnackbar({
                    text: `Error occured`,
                    display: true,
                    color: 'red',
                });
            }

            this.setOverlay(false);
            this.setLoading(false);
        },

        async deleteStudentConfirm () {            
            this.closeDelete();

            this.$nextTick(() => {
                this.setOverlay(true);
                this.setLoading(true);
            })

            try {
                await this.deleteTable1Record();               

                await this.setStudentRecords();

                this.setSnackbar({
                    text: `${this.selectedTable1Record.first_name} ${this.selectedTable1Record.last_name} deleted.`,
                    display: true,
                    color: 'primary',
                });
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.setSnackbar({
                    text: `Error occured`,
                    display: true,
                    color: 'red',
                });
            }

            this.setOverlay(false);
            this.setLoading(false);
        },

        setSelectedTerm (item) { 
            this.srcObject.term = item.term;
            this.selectedTerm = item;
            
            if(this.srcObject.report == "mark-sheet"){
                //close select term dialog
                this.selectTerm = false;
            }
            else if (
                this.srcObject.report == "rank-sheet" ||
                this.srcObject.report == "report-card"  
            ) {
                this.src = null;

                this.src = this.srcUrl(this.srcObject)
               
                this.setExpandTerms(false);

                setTimeout(() => {
                    this.setOverlay(false);
                    this.openReport();
                }, 700);
            }
           
           
        },

        setFormat () {           
            
            if(this.radioGroup == "excel"){
                this.setExpandTerms(false);
                this.download();
                return;
            }
            this.src = this.srcUrl(this.srcObject)
            this.openReport();

        },

        srcUrl(srcObject) {
            let src = `${this.srcObject.baseUrl}?`
            let currKey = null;
            let prevKey = null;
            let keyCount = 0;

            Object.keys(srcObject).forEach((key) => {
                currKey = key;
                if(key == "report" || key == "baseUrl"){
                    prevKey = currKey;
                    return;
                }
                keyCount++;
                if(keyCount == 1){
                    src += `${key}=${this.srcObject[key]}`;
                    prevKey = currKey;
                    return;
                }
                
                if(prevKey && prevKey != currKey){
                    src += `&${key}=${this.srcObject[key]}`;
                    
                }
                prevKey = currKey;
            })
            return src;
        },

        openReport () {      
            this.setDialogReport(true);
            if(!this.reportLoaded) this.overlayReport = true;
        },

        download () {
            this.setLoading(true);
            this.setOverlay(true);
            let fileName = this.srcObject.classId + ' Marksheet '
            + this.selectedTerm.title + ' '
            + this.srcObject.year + '-' + (this.srcObject.year + 1) + '.xlsx';
            this.downloadExcelMarksheet()
            .then(response => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                link.setAttribute('download', fileName);
               
                document.body.appendChild(link);
                link.click();
                       
            })
            .catch( error => {
                error.response ? console.log(error.response) : console.log(error);
                this.snackbar.text = 'Error Occured. Could not download file.';
                this.snackbar.color = 'red';
                this.snackbar.display = true;
                
            })
            setTimeout(() => {
                this.setOverlay(false);
                this.setLoading(false);
            }, 600)
        },

        closeReport () {
            this.setOverlay(false);
            this.overlayReport = false;
            this.setSrc(null);
            this.reportLoaded = false;
            this.setExpandTerms(false);            
            this.setDialogReport(false);
            // this.src = null;
        },

        closeReportMenu () {            
            this.setExpandTerms(false);
            setTimeout(() => {
                this.setOverlay(false);
            }, 600)                       
        },

        pdfLoaded () {
            this.reportLoaded = true;
            this.overlayReport = false;
        },

        setOverlayProcessing (val){
            this.overlayProcessing = val;
        }

       
       
    },

}
</script>

<style scoped>
    ::v-deep .v-text-field__slot textarea{
        font-size: 0.8rem;
    }

    ::v-deep .v-card__title{
        word-break: keep-all;
    }
</style>